import React from "react";

const Submit = ({ path = "", left = "", submit }) => {
  return (
    <div>
      <button type="submit" className="btn btn-primary">
        {submit}&nbsp; <i className="fa fa-angle-right" />
      </button>
    </div>
  );
};

export default Submit;
